import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Switch,
  message,
  Upload,
  Spin,
} from "antd";
import { DeleteOutlined, InboxOutlined } from "@ant-design/icons";

import { useNavigate } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { addImpact } from "../../Redux/CampaignSlice";
import { Editor } from "@tinymce/tinymce-react";
import "../../index.css";
import Cookies from "universal-cookie";
import { createCampaign } from "../../Services/services/dashboadapi";
import { debounce } from "lodash";


const { Option } = Select;
const { useForm } = Form;

const Campaign = () => {
  const isMenuOpen = useSelector((state) => state.sidebar.isMenuOpen);
  const editorRef = useRef(null);
  const navigate = useNavigate();
  const [documents, setDocuments] = useState([]);
  const [authorizedDocuments, setAuthorizedDocuments] = useState([]);
  const [form] = useForm();
  const [impactForm] = useForm();
  const [newCauseForm] = useForm();
  const today = moment();
  const [open, setOpen] = useState(false);
  const [newCauseOpen, setNewCauseOpen] = useState(false);
  const [causes, setCauses] = useState([]);
  const [isIndividual, setIsIndividual] = useState(false);
  const [donationTypes, setDonationTypes] = React.useState(["general"]);
  const [loading, setLoading] = useState(false);
  const [coverImageloading, setCoverImageloading] = useState(false);
  const [causeVal, setCauseVal] = useState("");
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [key, setKeyF] = useState("");
  const [uploadedImages, setUploadedImages] = useState([]);
  const [createLoader, setCreateLoader] = useState(false);

  // Handle FormData
  const [formData, setFormData] = useState({
    campaignName: "",
    campaignDescription: "",
    goal: "",
    cause: "",
    startDate: "",
    endDate: "",
    donationTypes: donationTypes,
    files: "",
  });

  const isDisabled =
  !formData.campaignName ||
  !formData.campaignDescription ||
  !formData.goal ||
  !formData.cause ||
  !formData.startDate ||
  !formData.endDate ||
  !formData.donationTypes ||
  (isIndividual && !formData.files);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    // console.log("Form Data :", formData);
  };

  const dispatch = useDispatch();
  const impacts = useSelector((state) => state.campaign.impacts);
  const cookies = new Cookies();
  const token = cookies.get("jwtToken");

  useEffect(() => {
    const fetchCauses = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL_DASHBOARD_URL}/cause`
        );
        if (response.data && Array.isArray(response.data.causes)) {
          setCauses(response.data.causes);
        } else {
          throw new Error("API response does not contain causes array");
        }
      } catch (error) {
        console.error("Error fetching causes:", error);
        message.error(error.response.data.error);
      }
    };

    fetchCauses();
  }, []);

  useEffect(() => {
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setIsIndividual(decodedToken.role === "individual");
      } catch (error) {
        console.error("Failed to decode token:", error);
      }
    } else {
      console.warn("No token found in cookies");
    }
  }, [token]);

  const handleOk = () => {
    impactForm
      .validateFields()
      .then((values) => {
        dispatch(addImpact(values));
        message.success("Impact added successfully!");
        impactForm.resetFields();
        setOpen(false);
      })
      .catch((info) => {
        message.error("Please fill in the required fields.");
      });
  };

  const tinyMceContext = () => {
    if (editorRef.current) {
      return editorRef.current.getContent();
    }
  };

  const handleNewCauseOk = async () => {
    try {
      const values = await newCauseForm.validateFields();
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL_DASHBOARD_URL}/cause`,
        values
      );
      setCauses([...causes, response.data]);
      message.success("Cause added successfully!");
      setNewCauseOpen(false);
      newCauseForm.resetFields();
    } catch (error) {
      message.error("Failed to add cause");
    }
  };

  const uploadDocument = async (
    file,
    setLoading,
    setUploadSuccess,
    setMessage,
    setKey
  ) => {
    setLoading(true);
    const token = cookies.get("jwtToken");
    const filename = file.name;

    try {
      const uploadResponse = await axios.post(
        `${import.meta.env.VITE_API_URL}/upload/open_file_upload`,
        { filename: filename.replace(/\s+/g, "_") },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const { url, key } = uploadResponse.data;

      const s3UploadResponse = await fetch(url, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type,
        },
      });

      if (s3UploadResponse.ok) {
        // message.success("Document uploaded successfully!");
        setUploadSuccess(true);
        setMessage(filename);
        // setKeyF(key); // This can stay if you still need to update the state
        return uploadResponse.data.key; // Return the key
      } else {
        throw new Error("Failed to upload file to S3");
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      message.error("An error occurred while uploading the document.");
      setUploadSuccess(false);
    }
    setLoading(false);
  };

  const handleDocumentUpload = async ({ file, onSuccess, onError }) => {
    setLoading(true);
    try {
      const key = await uploadDocument(
        file,
        setCoverImageloading,
        (success) => {
          if (!success) {
            onError(new Error("Failed to upload document"));
          }
        },
        (filename) => message.success(`${filename} uploaded successfully!`)
      );

      if (key) {
        setDocuments((prevDocs) => [
          ...prevDocs,
          {
            uid: file.uid,
            url: `${import.meta.env.VITE_API_CLOUDFRONT_URL}${key}`,
            name: file.name,
          },
        ]);

        onSuccess(null, file);
      } else {
        onError(new Error("Failed to upload document: Key not received"));
      }
    } catch (error) {
      console.error("Error during document upload:", error);
      message.error("An error occurred while uploading the document.");
      onError(error);
    } finally {
      setCoverImageloading(false);
    }
  };

  const handleAuthorizedDocumentUpload = async ({
    file,
    onSuccess,
    onError,
  }) => {
    setLoading(true);
    uploadDocument(
      file,
      setLoading,
      (success) => {
        if (success) {
          setAuthorizedDocuments((prevDocs) => [
            ...prevDocs,
            {
              url: `${import.meta.env.VITE_API_CLOUDFRONT_URL}${file.name}`,
              uid: file.uid,
            },
          ]);
          onSuccess(null, file);
        } else {
          onError(new Error("Failed to upload document"));
        }
      },
      (filename) => message.success(`${filename} uploaded successfully!`)
    );
  };

  const handleRemoveImage = (uid) => {
    setDocuments((prevDocs) => prevDocs.filter((doc) => doc.uid !== uid));
  };

  const handleRemoveAuthorizedImage = (uid) => {
    setAuthorizedDocuments((prevDocs) =>
      prevDocs.filter((doc) => doc.uid !== uid)
    );
  };

  const handleUrlKeyPress = (event) => {
    if (event.key === " ") {
      event.preventDefault();
      const { value } = event.target;
      event.target.value = value + "-";
    }
  };

  const handleEditorChange = (content, editor) => {
    setFormData((prevData) => ({
      ...prevData,
      campaignDescription: content,
    }));
  };

  const onFinish = async (values) => {
    const goal = parseFloat(values.goal);
    const campaignData = {
      name: values.name,
      description: tinyMceContext(),
      goal: goal,
      currency: "INR",
      cause: values.cause,
      dates: {
        start_date: values.startDate
          ? values.startDate.toISOString()
          : today.toISOString(),
        last_date: values.endDate ? values.endDate.toISOString() : null,
      },
      status: values.isActive ? "active" : "draft",
      impacts: impacts,
      cover: documents, // Now includes the key added in handleDocumentUpload
      documents: authorizedDocuments.map((doc) => doc.url),
      donation_types: donationTypes,
    };
    // console.log(`Campaign Data : ${campaignData}`);

    try {
      if (campaignData.cover.length === 0) {
        message.error("Please upload cover image first");
      } else {
        await createCampaign(campaignData); // Use the API call directly

        message.success("Campaign created successfully!");
        navigate("/dashboard");
      }
    } catch (error) {
      message.error(error.response.data.error[0]);
    }
  };

  const disablePastDates = (current) => {
    return current && current < moment().startOf("day");
  };

  const showModal = () => {
    setOpen(true);
  };

  const showNewCauseModal = () => {
    setNewCauseOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleNewCauseCancel = () => {
    setNewCauseOpen(false);
  };
  const handleDateChange = (date, dateString, fieldName) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: date, // Update the corresponding field (startDate or endDate)
    }));
    console.log("Form data : ", formData);
  };

  const handleCauseChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      cause: value, // Update 'causes' directly with the selected value
    }));
    console.log("Form data : ", formData);
  };

  const disableEndDate = (current) => {
    if (!formData.startDate) return current.isBefore(moment(), "day");

    return current.isBefore(formData.startDate, "day");
  };

  return (
    <div
      className={`bg-[#41c0e0] sm:p-4 pt-10 min-h-screen ${
        isMenuOpen ? "ml-64 " : "ml-10"
      } transition-all duration-300`}
    >
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow">
        <div className="flex mb-6">
          <h1 className="text-xl font-bold">Create Campaign</h1>
          <Button
            type="primary"
            className="ml-auto bg-[#2d98b3]"
            onClick={showModal}
          >
            Add Impact
          </Button>
        </div>
        <Modal
          open={open}
          title="Add Impact"
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[
            <Button key="back" onClick={handleCancel}>
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={handleOk}>
              Submit
            </Button>,
          ]}
        >
          <Form
            form={impactForm}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            layout="vertical"
          >
            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: "Please enter title" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Description"
              name="description"
              rules={[{ required: true, message: "Please enter description" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Amount"
              name="amount"
              type="submit"
              rules={[{ required: true, message: "Please enter count" }]}
            >
              <Input type="number" />
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          open={newCauseOpen}
          title="Add Cause"
          onOk={handleNewCauseOk}
          onCancel={handleNewCauseCancel}
          className="mt-16"
          footer={[
            <Button key="back" onClick={handleNewCauseCancel}>
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={handleNewCauseOk}>
              Submit
            </Button>,
          ]}
        >
          <Form
            form={newCauseForm}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            layout="vertical"
          >
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Please enter name" }]}
            >
              <Input
                value={causeVal}
                onChange={(event) => {
                  const inputValue = event.target.value;
                  const capitalizedValue =
                    inputValue.charAt(0).toUpperCase() +
                    inputValue.slice(1).toLowerCase();
                    // console.log(capitalizedValue)
                  setCauseVal(capitalizedValue);
                }}
                style={{ textTransform: "capitalize" }} // Apply uppercase styling to the input directly
              />
            </Form.Item>
          </Form>
        </Modal>
        <Form
          form={form}
          onFinish={onFinish}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          layout="vertical"
        >
          <Form.Item
            label="Campaign Name"
            name="name"
            rules={[{ required: true, message: "Please enter campaign name" }]}
          >
            <Input
              className="input-style"
              name="campaignName"
              value={formData.campaignName}
              onChange={handleInputChange}
            />
          </Form.Item>
          <Form.Item
            label="Campaign Description"
            name="description"
            rules={[{ required: true, message: "Please enter description" }]}
          >
            <Editor
              apiKey="vle3luqfs1chxeoib73634clbofjnixkfjtyhrjbeggnd8xu"
              value={formData.campaignDescription} // Sync value with form data
              onInit={(evt, editor) => (editorRef.current = editor)}
              onEditorChange={handleEditorChange} // Update form data on change
              init={{
                height: 300,
                menubar: false,
                plugins: [
                  "advlist autolink lists link image charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code help wordcount",
                ],
                toolbar:
                  "undo redo | formatselect | bold italic backcolor | \
               alignleft aligncenter alignright alignjustify | \
               bullist numlist outdent indent | removeformat | help",
              }}
            />
          </Form.Item>
          <Form.Item
            label="Goal"
            name="goal"
            rules={[{ required: true, message: "Please enter goal amount" }]}
          >
            <Input
              name="goal"
              type="number"
              className="input-style"
              value={formData.goal}
              onChange={handleInputChange}
            />
          </Form.Item>

          <Form.Item
            label="Cause"
            name="cause"
            rules={[{ required: true, message: "Please select a cause" }]}
          >
            <Select
              className="input-style"
              value={formData.causes} // Update with formData.cause instead of formData.campaignName
              onChange={handleCauseChange} // Ensure the handler updates the 'cause' field in formData
            >
              {causes.map((cause) => (
                <Option key={cause._id} value={cause._id}>
                  {cause.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Button
            type="primary"
            className="ml-20 bg-[#2d98b3] left-3/4 "
            onClick={showNewCauseModal}
          >
            Add Cause
          </Button>
          <div className="grid grid-cols-2 gap-2">
            <Form.Item
              label="Start Date"
              name="startDate"
              rules={[
                { required: true, message: "Please select a start date" },
              ]}
            >
              <DatePicker
                value={formData.startDate}
                onChange={(date, dateString) =>
                  handleDateChange(date, dateString, "startDate")
                }
                className="input-style"
                disabledDate={disablePastDates} // You can keep the past date disabled
              />
            </Form.Item>

            <Form.Item label="End Date" name="endDate">
              <DatePicker
                value={formData.endDate}
                onChange={(date, dateString) =>
                  handleDateChange(date, dateString, "endDate")
                }
                className="input-style"
                disabledDate={disableEndDate} // Disable dates based on the start date
              />
            </Form.Item>
          </div>
          <div className="mb-24">
            <Form
              initialValues={{
                donation_types: ["General"], // Set the initial value for donation_types
              }}
            >
              <Form.Item
                label="Donation Types"
                name="donation_types"
                rules={[
                  {
                    required: true,
                    message: "Please enter at least one donation type",
                  },
                ]}
              >
                <Select
                  mode="tags"
                  className="input-style "
                  onChange={(value) => setDonationTypes(value)} // Update state when selection changes
                  placeholder="Enter donation types"
                />
              </Form.Item>
            </Form>
          </div>
          <Form.Item
            label="Active"
            name="isActive"
            valuePropName="checked"
            initialValue={true}
          >
            <Switch defaultChecked />
          </Form.Item>
          <Form.Item label="Cover Image">
            <Spin spinning={coverImageloading}>
              <Upload.Dragger
                name="files"
                customRequest={handleDocumentUpload}
                multiple={false}
                accept=".jpg,.jpeg,.png"
                showUploadList={false}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
                <p className="ant-upload-hint">Upload campaign cover image</p>
              </Upload.Dragger>
            </Spin>
          </Form.Item>

          <div className="flex ">
            {documents.map((doc) => (
              <div
                key={doc.uid}
                className="flex flex-col items-center bg-gray-100 shadow-md rounded-md p-4 mx-2 w-24 space-y-2 mb-5"
              >
                <img
                  src={doc.url}
                  alt={doc.name}
                  className="w-16 h-16 rounded-md object-cover border border-gray-300"
                />
                <Button
                  type="text"
                  icon={<DeleteOutlined />}
                  onClick={() => handleRemoveImage(doc.uid)}
                  className="text-red-500 hover:text-red-600"
                />
              </div>
            ))}
          </div>

          {isIndividual && (
            <Form.Item
              label="Authorized Document"
              name="authorizedDocument"
              rules={[
                { required: isIndividual?true:false, message: "Kindly Upload the Documents" },
              ]}
              onChange={handleInputChange}
            >
              <Upload.Dragger
                name="files"
                accept=".pdf,.doc"
                customRequest={handleAuthorizedDocumentUpload}
                multiple={false}
                onRemove={(file) => handleRemoveAuthorizedImage(file.uid)}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Upload authorized document for verification
                </p>
              </Upload.Dragger>
            </Form.Item>
          )}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={createLoader}
              disabled={isDisabled}
              style={{
                backgroundColor: isDisabled ? "gray" : "",
                color: isDisabled ? "white" : "black",
              }}
            >
              Create Campaign
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Campaign;
